import { sports } from '@scoutgg/scoring-rules'
import sources from '../../../helpers/sources'
import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './leagues.jade'
import '@scoutgg/ftw/source/atoms/toggle/toggle'
import '@scoutgg/ftw/source/atoms/icons/icons'
import '@scoutgg/ftw/source/atoms/calendar/calendar'
import notify from '@scoutgg/ftw/source/services/notification'
import { prompt } from '@scoutgg/ftw/source/services/modal'
import {Season, League} from '../../models'
import '../status'

@Component('sporty')
@Template(template)
@Attribute('season', Season)
@Attribute('show-inactive', Boolean)
export default class Leagues extends HTMLElement {
  created() {
    this.newLeagueYear = (new Date()).getFullYear()
  }

  attached() {
    this.customStrategy = false
    this.reload()
  }

  reload() {
    this.update(Season.load({$reload: true}))
  }

  showForm(season) {
    this.$showForm = season
    this.render()
  }

  async changeSource(prop, source, e) {
    const v = source[prop]
    try {
      await source.post('update-prop', {
        [prop]: v,
        prop,
      })
      notify(`Updated ${prop}.`, {
        level: 'success',
        timeout: 2500,
      })
    } catch (e) {
      notify(e.message, {
        level: 'danger',
        timeout: 5000,
      })
    }
    this.render()
  }

  rename(league, e) {
    e && e.preventDefault()
    league.save().then(() => {
      notify(`League ${league._id} has been changed.`, {
        level: 'success',
        timeout: 5000,
      })
    }).catch(err => {
      notify(err.message, {
        level: 'danger',
        timeout: 10000,
      })
    })
  }

  isGoingToChangeSport(league, sport) {
    league.temporarySport = sport
    league.sportChanging = true
    this.render()
  }

  setSport(league, sport) {
    league.sport = league.temporarySport
    this.rename(league)
    league.sportChanging = false
    this.render()
  }

  async saveLiveSteam(season) {
    season.save().then(() => {
      notify(`season ${season._id} has been saved.`, {
        level: 'success',
        timeout: 2500,
      })
    }).catch(err => {
      notify(err.message, {
        level: 'danger',
        timeout: 10000,
      })
    })

  }

  changeSport(sport) {
    this.sport = sport || null
    this.render()
  }

  dontSetSport(league) {
    league.sportChanging = false
    this.render()
  }

  toggle(season, attr) {
    const flipped = !season[attr]
    season[attr] = flipped
    season.save().then(() => {
      notify(`Season ${season._id} is now ${flipped ? '' : 'not'} ${attr}`, {
        level: 'success',
        timeout: 5000,
      })
      if(!flipped && attr === 'active') {
        var seasonFilter = JSON.parse(localStorage.getItem('season-filter'))
        var index = seasonFilter.indexOf(season._id)
        if(index >= 0) {
          seasonFilter.splice(index, 1)
          localStorage.setItem('season-filter', JSON.stringify(seasonFilter))
        }
      }
    }).catch(err => {
      notify(err.message, {
        level: 'danger',
        timeout: 10000,
      })
      season[attr] = !flipped
      this.render()
    })
    this.render()
  }

  async updateScrapeFrom(season, scrapeFrom) {
    if(!this.canScrapeFrom(season)) {
      return
    }
    try {
      await season.post('update-scrape-from', {
        scrapeFrom,
      })
      notify(`Updated scrape from.`, {
        level: 'success',
        timeout: 2500,
      })
    } catch (e) {
      notify(e.message, {
        level: 'danger',
        timeout: 5000,
      })
    }
    this.render()
  }

  scrape(season, type) {
    if(season.$isScraping) return
    season.$isScraping = true
    season.post('scrape' + (type || '')).then(() => {
      notify(`Instructed the worker to scrape ${season.league.name} ${season.year}`, {
        level: 'success',
        timeout: 5000,
      })
    }).catch(err => {
      notify(err.message, {
        level: 'danger',
        timeout: 10000,
      })
    }).then(() => {
      season.$isScraping = false
      this.render()
    })
    this.render()
  }

  sourceProperty(season, property) {
    return (sources[season.source] || {})[property]
  }

  revealToken(season) {
    if(season.$isSubmitting) return
    season.$isSubmitting = true
    season
      .post('token')
      .then(res => { season.token = res.token })
      .catch(err => { notify(err.message, {level: 'danger', timeout: 1000}) })
      .then(res => {
        season.$isSubmitting = false
        this.render()
      })
  }

  toggleAuto(season) {
    if(season.$isSubmitting) return
    const state = !!season.auto
    season.$isSubmitting = true
    season.post(`toggle-auto`).then(() => {
      notify(`Auto-scraping ${state ? 'enabled' : 'disabled'}`, {
        level: 'success',
        timeout: 5000,
      })
    }).catch(err => {
      notify(err.message, {level: 'danger', timeout: 1000})
    }).then(() => {
      season.$isSubmitting = false
      season.auto = !state
      this.render()
    })
  }

  sortedSeasons(league) {
    return this.seasons
      .filter(s => s.league === league)
      .filter(s => this.showInactive || s.active)
      .sort((b, a) => a.season - b.season)
  }

  seasonClass(season) {
    if(season.active) return 'active'
  }

  send(season, type) {
    if(season.$isSubmitting) return
    season.$isSubmtting = true
    season.post(`send-${type}`).then(() => {
      notify(`Sending of ${type} is completed`, {
        level: 'success',
        timeout: 5000,
      })
    }).catch(err => {
      notify(err.message, {level: 'danger', timeout: 1000})
    }).then(() => {
      season.$isSubmitting = false
      this.render()
    })
    this.render()
  }

  createLeague() {
    League.save({
      name: this.newLeagueName,
      sport: this.sport,
      season: this.newLeagueYear,
    }).then(league => {
      this.reload()
    }).catch(err => {
      console.error(err)
      notify(err.message, {level: 'danger', timeout: 1000})
    })
  }

  sources(league) {
    return Object.keys(sources)
      .filter(source => sources[source].sport === league.sport)
      .map(source => sources[source])
  }

  sourcesFor(season) {
    const ret = this.seasonSources.filter(source => source.season === season)
    for(const source of ret) {
      source.name = (sources[source.source] || {}).name || 'unknown'
    }
    return ret
  }

  toggleReceiver(season, receiver) {
    var index
    if(~(index = season.receivers.indexOf(receiver._id))) {
      season.receivers.splice(index, 1)
    } else {
      season.receivers.push(receiver._id)
    }
    season.save()
  }

  async copy(season) {
    const question = `
      You are about to copy ${season.league.name} ${season.season}
      (${season._id})

      To which Season should it be copied?
    `

    const year = await prompt(question, {
      type: 'number',
      level: 'warning',
      submitBtnName: 'Copy',
      cancelBtnName: 'Abort',
      answer: season.season + 1,
    })
    if(!year) throw new Error('no year supplied')

    const pricedOnly = await prompt('Only copy priced players?', {
      type: 'yesno',
      level: 'warning',
      yesBtnName: 'Only Priced',
      noBtnName: 'All Players',
    }).catch(err => {
      if(err === 'cancelled') {
        return false
      }
      throw err
    })

    await season.post('copy', { year, pricedOnly })
    this.reload()
  }

  async destroy(season) {
    const question = `
      You are about to destroy ${season.league.name} ${season.season}

      To confirm, enter the season's ID:
    `

    const id = await prompt(question, {
      type: 'text',
      level: 'danger',
      submitBtnName: 'Destroy',
      cancelBtnName: 'Abort',
    })
    if(id !== season._id) {
      throw new Error('id_mismatch')
    }
    await season.destroy()
    this.reload()
  }

  canScrapeFrom(source) {
    if(this.sourceProperty(source, 'csvOnly')) {
      return false
    }
    return [
      'csgo',
      'dota2',
      'lol',
    ].includes(source.sport)
  }

  toggleLeague(league) {
    if(league === this.showLeague) league = null
    this.applyState({
      showLeague: league,
    })
  }

  lastUpdate(league) {
    if(league.updatedAt) {
      return league.updatedAt.format('ll')
    } else {
      return '-'
    }
  }

  get sports() {
    return sports.sort()
  }

  get filteredLeagues() {
    const active = (this.seasons || [])
      .filter(s => s.active)
      .map(s => s.league)
      .reduce((set, l) => set.add(l), new Set())
    return (this.leagues || [])
      .filter(l => this.showInactive || active.has(l))
      .filter(l => !this.sport || this.sport === l.sport)
  }

  get getSportChoise() {
    return this.sportChoise
  }

  get uploadSeasonJsonPath() {
    return '/seasons/restore'
  }
}
